import React from 'react'
import HeroSection from '../Sections/Resoration/Hero'
import Section1 from '../Sections/Resoration/Section1'
import Section2 from '../Sections/Resoration/Section2'
import Nissan from '../Sections/Resoration/Nissan'
import Final from '../Sections/Resoration/Final'
function Restoratoin() {
  return (
  <>
  <HeroSection/>
  <Section1/>
  <Section2/>
  <Nissan/>
  <Final/>
  </>
  )
}

export default Restoratoin
